import React, { memo } from 'react';
import { FormControlLabel, Checkbox as MuiCheckbox } from '@mui/material';
import { ReactComponent as CheckboxDefault } from '../../../../assets/icons/CheckboxDefault.svg';
import { ReactComponent as CheckboxChecked } from '../../../../assets/icons/CheckboxChecked.svg';

import { useStyles } from './styles';
import ControlledError from '../ControlledError';

export interface ICheckboxProps {
  name?: string;
  value?: string | number;
  checked?: boolean;
  label: React.ReactNode;
  color?: 'primary' | 'secondary' | 'success' | 'error' | 'info' | 'warning';
  disabled?: boolean;
  styleClass?: string;
  error?: string;
  testId?: string;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onMouseDown?: (event: React.MouseEvent<HTMLLabelElement, MouseEvent>) => void;
}

const Checkbox = ({
  name,
  value,
  checked,
  label,
  color = 'primary',
  disabled = false,
  error,
  styleClass,
  testId,
  onChange,
  onMouseDown,
}: ICheckboxProps) => {
  const classes = useStyles();
  return (
    <ControlledError show={!!error} error={!!error && error}>
      <FormControlLabel
        data-testid={testId}
        control={
          <MuiCheckbox
            name={name}
            value={value}
            checked={checked}
            color={color}
            disableRipple
            disabled={disabled}
            onChange={onChange}
            icon={<CheckboxDefault />}
            checkedIcon={<CheckboxChecked />}
          />
        }
        onMouseDown={onMouseDown}
        label={label}
        className={`${classes.checkbox} ${styleClass || ''}`}
      />
    </ControlledError>
  );
};

export default memo(Checkbox);
